function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M21.171 11.046c0-.736-.061-1.47-.186-2.196H10.8v4.16h5.834c-.242 1.342-1.02 2.528-2.158 3.281v2.7h3.482c2.039-1.879 3.213-4.659 3.213-7.945z",
  transform: "translate(-638 -1231) translate(429 793) translate(30 426) translate(179 12)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M10.8 21.6c2.914 0 5.369-.957 7.158-2.607l-3.481-2.7c-.97.657-2.218 1.032-3.677 1.032-2.817 0-5.208-1.899-6.063-4.458H1.15v2.782c1.834 3.648 5.567 5.95 9.65 5.951z",
  transform: "translate(-638 -1231) translate(429 793) translate(30 426) translate(179 12)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M4.737 12.867c-.452-1.34-.452-2.793 0-4.134V5.95H1.15c-1.533 3.052-1.533 6.648 0 9.7l3.587-2.783z",
  transform: "translate(-638 -1231) translate(429 793) translate(30 426) translate(179 12)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M10.8 4.275c1.54-.025 3.028.557 4.143 1.62l3.083-3.082C16.07.976 13.48-.031 10.8 0 6.717 0 2.984 2.303 1.15 5.95l3.587 2.783c.855-2.559 3.246-4.458 6.063-4.458z",
  transform: "translate(-638 -1231) translate(429 793) translate(30 426) translate(179 12)"
}))))));

function SvgGooglePayGPayLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayGPayLogo);
export default __webpack_public_path__ + "static/media/google-pay-g-pay-logo.e0b9b5f0.svg";
export { ForwardRef as ReactComponent };